export default __webpack_public_path__ + "static/media/dash_take_assessment.fee80b1c.svg";